/* eslint-disable sort-keys */
import { FormattedMessage } from 'react-intl'
import { useCurrentAppType } from 'hooks'
import { Box, Button, Typography } from '@mui/material'
import useAnalytics from 'hooks/useAnalytics'

const WelcomeSectionResources = () => {
  const { isVeteran, isResponder } = useCurrentAppType()
  const { sendEvent } = useAnalytics()
  const mask = '/images/welcome/mask-resources.svg'
  const mobileMask = '/images/welcome/mask-tools-mobile.svg'

  // TEMPLATE VARIABLES
  let PDF, headline, content, documentImage1, documentImage2

  // VETERAN COPY
  if (isVeteran) {
    headline = 'Not ready for an account? Here’s a sample.'
    content = (
      <Box sx={{ display: 'flex', flexDirection: 'column', gridGap: 8 }}>
        <Typography pb={2} pt=".5em" variant="body1">
          The right support looks different for each of us - especially
          Veterans. Whether it’s an online resource to handle a tricky
          situation, talking to a friend or professional about a FUBARED
          situation.
        </Typography>
        <Typography pb={2} pt=".5em" variant="body1">
          Download the top 3 resources every Veteran, friend, or family member
          should have on hand as a sample of what you’ll find inside your free
          Operation Veteran Strong account.
        </Typography>
      </Box>
    )
    PDF = '/pdfs/ovs_resources_download.pdf'
    documentImage1 = '/images/welcome/documents-images/OVS_PDFicon_1.png'
    documentImage2 = '/images/welcome/documents-images/OVS_PDFicon_2.png'
  }

  // RESPONDER COPY
  if (isResponder) {
    PDF = '/pdfs/responder_resources_download.pdf'
    headline = 'Top 3 resources every emergency responder should know'
    content = (
      <Typography pb={2} pt=".5em" variant="body1">
        Whether it’s for you, or a responder in your life, download this PDF to
        have the best resources on hand whenever you need them.
      </Typography>
    )
    documentImage1 = '/images/welcome/documents-images/RS_PDFicon_1.png'
    documentImage2 = '/images/welcome/documents-images/RS_PDFicon_2.png'
  }

  const ContentSection = () => (
    <Box
      sx={{
        color: 'white',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        ml: { xs: 'initial', lg: '4em' },
        px: { xs: 1, lg: 0 },
        width: { xs: 'initial', lg: '65%' }
      }}
    >
      <Typography tabIndex={0} variant="h3">
        <FormattedMessage
          defaultMessage="{headline}"
          id="AEeXEL"
          values={{ headline }}
        />
      </Typography>
      {content}
      <DownloadButton />
    </Box>
  )

  const DocumentsImage = () => (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: 'fit-content',
        justifyContent: 'center',
        mb: { xs: 2.5, lg: 0 },
        ml: { xs: '7%', sm: '8%', md: '15%', lg: 0 },
        position: 'relative',
        width: { xs: '10em', sm: '12em' }
      }}
    >
      <Box
        sx={{
          background: `url(${documentImage2})`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          height: 240,
          left: 70,
          position: 'absolute',
          transform: 'rotate(8deg)',
          width: 240
        }}
      />
      <Box
        sx={{
          background: `url(${documentImage1})`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          height: 240,
          left: 40,
          position: 'absolute',
          transform: 'rotate(-8deg)',
          width: 240
        }}
      />
    </Box>
  )

  const DownloadButton = () => (
    <Button
      download
      href={PDF}
      LinkComponent="a"
      onClick={() =>
        sendEvent('welcome_page', {
          section: 'resources',
          element_title: 'download pdf',
          click_element: 'button'
        })
      }
      variant="download-pdf"
    >
      <FormattedMessage defaultMessage="Download PDF" id="TclprG" />
    </Button>
  )

  const maskStyles = {
    '& svg': {
      fill: '#FFCC00'
    },
    display: 'flex',
    height: { xs: 667, md: 450 },
    maskImage: { xs: `url(${mobileMask})`, lg: `url(${mask})` },
    maskRepeat: 'no-repeat',
    maskSize: 'cover',
    pt: { xs: '30%', md: '95%', lg: '50%' },
    width: '90%'
  }

  return (
    <Box
      sx={{
        alignItems: 'center',
        bgcolor: 'white',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        mb: '10%',
        pt: '15%',
        width: '100vw'
      }}
    >
      <Box
        sx={{
          bgcolor: 'school.secondary',
          ml: { xs: '-5%', md: '-2%' },
          mt: { xs: '6%', md: '-2%' },
          ...maskStyles
        }}
      />
      <Box
        sx={{
          bgcolor: 'school.primary',
          position: 'absolute',
          ...maskStyles
        }}
      />
      <Box
        sx={{
          alignItems: { xs: 'initial', lg: 'center' },
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
          height: { xs: '70%', md: '65%', lg: '55%' },
          justifyContent: 'space-around',
          left: { xs: 'initial', md: '11%', lg: 'initial' },
          position: 'absolute',
          width: { xs: '80%', md: '45%', lg: '85%' }
        }}
      >
        <DocumentsImage />
        <ContentSection />
      </Box>
    </Box>
  )
}

export default WelcomeSectionResources
